import { produce, Draft } from 'immer'
//import {ID} from "../common/types";
//import {BankCard} from "../common/types/bank";
//import accommodation from "./accommodation";
//import checkin from "./checkin";

type CompletionRates = {
  byBooker: Object
  byFolder: Object
  byPax: Object
  global: Object
}

type AddPrechckinActionData = {
  accommodationServices: Array<object>,
  booker: Number,
  bookingFolder: Object,
  bookingPaxes: Array<object>,
  bookings: Array<object>,
  checkInFieldParameters: Object,
  completionRates: CompletionRates,
  customerFiles: Array<object>,
  isBookerPax: Object,
  isFromSelfCheckin: boolean
}

type Payload = {
  addPrechckinActionData: AddPrechckinActionData,
  currentIds: any
}

type State = {
  addPrechckinActionData: Object,
  currentIds: Object
  displayControl: any
}

const common = {
  state: {
    displayControl: {}
  } as State,
  reducers: {
    load: produce((draft: Draft<State>, payload: Partial<State>) => {
      Object.assign(draft, payload)
    })
  },
  effects: dispatch => ({
    async handleAddPreCheckInAction(payload: Payload, rootState) {
      const bookingsCompletionRates = payload.addPrechckinActionData.completionRates?.byFolder?.[parseInt(payload.currentIds?.bookingFolderId)]?.byBooking

      if(bookingsCompletionRates) {
        await dispatch.booking.updateBookingsCompletionRateAsync({
          bookingsCompletionRates: { bookingsCompletionRates },
          currentBookingId: payload.currentIds.bookingId,
          isFromSelfCheckin: payload.addPrechckinActionData.isFromSelfCheckin
        });
      }
      dispatch.booking.load({
        bookings: payload.addPrechckinActionData.bookings ?? [],
        bookingsCompletionRates: bookingsCompletionRates ?? {},
        bookingFolder: payload.addPrechckinActionData.bookingFolder,
      });
      dispatch.accommodation.loaded({
        accommodationServicesList: payload.addPrechckinActionData.accommodationServices
      })
      dispatch.checkin.load({
        checkInFieldParameters: payload.addPrechckinActionData?.checkInFieldParameters ?? {},
        completionRates: payload.addPrechckinActionData?.completionRates ?? {}
      })
      if (payload.addPrechckinActionData?.isBookerPax) {
        dispatch.booking.updateIsBookerPax(payload.addPrechckinActionData.isBookerPax);
      }

      //TODO Gerer update USER lorsque l'on aura déplacé USER du GlobalContext vers store
      /*if (payload.addPrechckinActionData.booker && payload.addPrechckinActionData.customerFiles) {
        let bookerData = payload.addPrechckinActionData.customerFiles.find(customerFile => parseInt(customerFile.id) === parseInt(payload.addPrechckinActionData.booker));
        if (bookerData !== undefined) {
          dispatch({ type: GlobalType.SET_USER, payload: bookerData });
        }
      }*/
    }
  })
}

export default common;